// Mock data for SubZero Coolers website

export const companyInfo = {
  name: "Sub-Zero Coolers, LLC",
  tagline: "Premium Commercial Refrigeration Solutions",
  phone: "772-362-9384",
  emergencyPhone: "772-353-7263",
  email: "devon.granda@subzerocoolers.net",
  ownerEmail: "subzerocoolers@outlook.com",
  address: "Serving Commercial Clients Across Florida",
  officeHours: "Monday - Friday: 9AM - 5PM",
  contacts: {
    admin: {
      name: "Devon Granda",
      title: "Executive Administrator",
      email: "devon.granda@subzerocoolers.net",
      phone: "772-362-9384"
    },
    owner: {
      name: "Luis Granda",
      title: "Owner/Manager",
      email: "subzerocoolers@outlook.com",
      phone: "772-353-7263"
    }
  }
};

export const heroData = {
  title: "Expert Commercial Refrigeration Services",
  subtitle: "Walk-in coolers, freezers, and refrigeration systems across Florida",
  description: "Built from determination and 20 years of industry experience. We deliver quality workmanship, reliability, and customer satisfaction on every project.",
  ctaPrimary: "Request a Quote",
  ctaSecondary: "Our Services",
  backgroundImage: "https://images.unsplash.com/photo-1762924352150-12b8c19bf4d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwa2l0Y2hlbiUyMHJlZnJpZ2VyYXRvciUyMGNvbW1lcmNpYWx8ZW58MHx8fHwxNzc2Mjg3MDM1fDA&ixlib=rb-4.1.0&q=85"
};

export const products = [
  {
    id: 1,
    name: "Walk-In Cooler Installation",
    description: "Custom walk-in coolers to fit your space and storage needs, providing optimal temperature control and energy efficiency with precision insulated panel setup.",
    features: ["Custom Design", "Energy Efficient", "Insulated Panels", "Complete Installation"],
    image: "https://images.pexels.com/photos/5953713/pexels-photo-5953713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Walk-In Builds"
  },
  {
    id: 2,
    name: "Walk-In Freezer Installation",
    description: "Walk-in freezers designed for high-volume storage, helping you preserve perishable goods safely and cost-effectively with seamless integration.",
    features: ["High-Volume Storage", "Airtight Sealing", "Complete Components", "Warranty Included"],
    image: "https://images.unsplash.com/photo-1719642357460-d0f611ebc108?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Walk-In Builds"
  },
  {
    id: 3,
    name: "Refrigerated Case Setting",
    description: "Professional installation of refrigerated supermarket cases with accurate lineup and leveling to ensure efficient operation and attractive product display.",
    features: ["Precise Alignment", "Professional Setup", "Optimal Performance", "Connection Prep"],
    image: "https://images.unsplash.com/photo-1601599561213-832382fd07ba?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Case Setting"
  },
  {
    id: 4,
    name: "Refrigeration System Installation",
    description: "Complete refrigeration system installs with expert piping, evaporator coils, and condensing units for reliable cooling and system longevity.",
    features: ["Complete Systems", "Expert Piping", "Quality Coils", "System Reliability"],
    image: "https://images.pexels.com/photos/5953713/pexels-photo-5953713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Refrigeration"
  },
  {
    id: 5,
    name: "Display Case Connections",
    description: "Secure and precise refrigerated display case connections ensuring cases operate at peak efficiency with consistent temperature control.",
    features: ["Secure Connections", "Peak Efficiency", "Temperature Control", "Modern Equipment"],
    image: "https://images.unsplash.com/photo-1613083042976-463bdde9ec51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwcmVmcmlnZXJhdGlvbnxlbnwwfHx8fDE3Nzk0NTYxMjd8MA&ixlib=rb-4.1.0&q=85",
    category: "Equipment"
  },
  {
    id: 6,
    name: "Remodel & Removal Services",
    description: "Safe and efficient demo/removal of existing equipment and complete remodel work, clearing the way for modern upgrades with minimal disruption.",
    features: ["Safe Removal", "Remodel Work", "Minimal Downtime", "Modern Upgrades"],
    image: "https://images.unsplash.com/photo-1601599967100-f16100982063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwcmVmcmlnZXJhdGlvbnxlbnwwfHx8fDE3Nzk0NTYxMjd8MA&ixlib=rb-4.1.0&q=85",
    category: "Remodel"
  }
];

export const services = [
  {
    id: 1,
    title: "Walk-In Cooler & Freezer Builds",
    description: "Expert construction services for walk-in coolers and freezers, handling every aspect from new installations to remodels, ensuring efficient operation and long-term durability.",
    icon: "wrench",
    features: [
      "Custom walk-in cooler & freezer installation",
      "Precision insulated panel setup",
      "Complete door, ceiling, wall, and floor installation",
      "New construction and remodel work",
      "Demo/removal of existing units",
      "Certified installers with warranties on all builds"
    ]
  },
  {
    id: 2,
    title: "Refrigerated Case Setting & Removal",
    description: "Specialized in setting up and removing refrigerated supermarket cases, creating functional and attractive retail environments with precise placement and connections.",
    icon: "settings",
    features: [
      "Professional refrigerated supermarket case setting",
      "Accurate lineup and leveling of cases",
      "Open-air merchandiser installation",
      "Case preparation for refrigeration connections",
      "Fast and careful removal of existing cases",
      "Trained in safe handling and installation practices"
    ]
  },
  {
    id: 3,
    title: "Commercial Supermarket Refrigeration",
    description: "Complete refrigeration system installation and equipment services tailored to your store's requirements, ensuring reliable cooling and peak efficiency.",
    icon: "pencil-ruler",
    features: [
      "Complete refrigeration system installation",
      "Expert refrigeration piping",
      "Evaporator coil installation",
      "Condensing unit setup",
      "Refrigerated display case connections",
      "Equipment replacement and upgrades"
    ]
  },
  {
    id: 4,
    title: "Quality & Experience",
    description: "Backed by years of industry experience and specialized certifications, our team is committed to quality workmanship, reliability, and customer satisfaction.",
    icon: "phone",
    features: [
      "Years of industry experience",
      "Specialized certifications",
      "Adherence to industry standards",
      "Service guarantees on all work",
      "Focus on seamless integration",
      "Airtight sealing for maximum efficiency"
    ]
  }
];

export const industries = [
  {
    name: "Restaurants & Food Service",
    description: "Keep your kitchen running with reliable commercial refrigeration built for high-volume food service.",
    icon: "utensils"
  },
  {
    name: "Grocery Stores & Supermarkets",
    description: "Display and preserve fresh products with energy-efficient coolers and freezers designed for retail.",
    icon: "shopping-cart"
  },
  {
    name: "Warehouses & Distribution",
    description: "Large-scale cold storage solutions for distribution centers requiring massive capacity and reliability.",
    icon: "warehouse"
  },
  {
    name: "Healthcare Facilities",
    description: "Precise temperature control for medical supplies, pharmaceuticals, and laboratory specimens.",
    icon: "heart-pulse"
  }
];

export const aboutContent = {
  mission: "Sub‑Zero Coolers, LLC exists to prove that starting small doesn't limit how far you can go. Built from nothing but determination, grit, and a belief in what's possible, we are a company that grows by outworking expectations and delivering craftsmanship our customers can trust.",
  vision: "Our vision is to become a leading force in walk‑in cooler construction and commercial refrigeration, known for reliability, precision, and a customer‑first mindset. We aim to expand our capabilities while staying grounded in the values that built this company: hard work, honesty, and doing the job right the first time. We are committed to going above and beyond for every customer — not because it's required, but because it's who we are.",
  foundingStory: "Sub-Zero Coolers was founded in 2023 by Luis Granda, who brought 20 years of refrigeration experience and a strong reputation in the industry. Built from the ground up with determination, hard work, and a clear vision for growth, the company began as a small operation specializing in walk-in cooler construction and case setting. Today, we are fully licensed and insured and equipped to meet a wide range of commercial refrigeration needs.",
  values: [
    {
      title: "Hard Work",
      description: "Built from determination and grit, we outwork expectations on every project.",
      icon: "award"
    },
    {
      title: "Honesty",
      description: "We conduct business with integrity and transparency in everything we do.",
      icon: "users"
    },
    {
      title: "Quality Craftsmanship",
      description: "Doing the job right the first time with precision and attention to detail.",
      icon: "lightbulb"
    },
    {
      title: "Customer First",
      description: "Going above and beyond for every customer because it's who we are.",
      icon: "shield-check"
    }
  ],
  stats: [
    { number: "2023", label: "Company Founded" },
    { number: "20+", label: "Years Experience" },
    { number: "FL", label: "Statewide Service" },
    { number: "100%", label: "Licensed & Insured" }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Florida Restaurant Owner",
    company: "Commercial Kitchen",
    role: "Business Owner",
    quote: "Professional installation of our walk-in cooler. Luis and his team were efficient, thorough, and the quality of work exceeded our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Supermarket Manager",
    company: "Florida Grocery Chain",
    role: "Store Manager",
    quote: "Sub-Zero Coolers handled our refrigerated case installation with precision. Their attention to detail and customer service is outstanding.",
    rating: 5
  },
  {
    id: 3,
    name: "Commercial Client",
    company: "Food Service Provider",
    role: "Operations Director",
    quote: "We've worked with Sub-Zero on multiple projects. Their expertise and reliability make them our go-to for all refrigeration needs.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "What types of businesses do you serve?",
    answer: "We serve restaurants, food service operations, grocery stores, supermarkets, warehouses, distribution centers, and any business requiring commercial refrigeration across Florida."
  },
  {
    question: "What are your service hours?",
    answer: "Our office hours are Monday through Friday, 9AM to 5PM. For service inquiries outside these hours, please leave a message and we'll get back to you on the next business day."
  },
  {
    question: "How long does installation take?",
    answer: "Installation time varies based on the system size and complexity. Walk-in coolers typically take 1-3 days, while larger custom installations may take 1-2 weeks. We work efficiently to minimize business disruption."
  },
  {
    question: "Do you provide maintenance contracts?",
    answer: "Yes! We offer comprehensive maintenance contracts with scheduled inspections and priority service to keep your systems running optimally."
  },
  {
    question: "What warranties do you offer?",
    answer: "All our equipment comes with manufacturer warranties. We also provide service guarantees on our installation work for your peace of mind."
  },
  {
    question: "Can you customize refrigeration systems?",
    answer: "Absolutely! Custom design is one of our specialties. We'll work with you to create a refrigeration solution perfectly tailored to your space and operational needs."
  }
];
